const triggerHapticFeedback = () => {
    if (navigator.vibrate) {
      navigator.vibrate(20);
    }
  };
  
  export default triggerHapticFeedback;
  